import React from "react";

export default function Footer({ space }) {
  return (
    <footer className="footer-section">
      <div className={`footer-top background-img-2 ${space ? "pt-150" : "pt-60"}`}>
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-12 col-lg-4 mb-4 mb-lg-0">
              <div className="footer-nav-wrap text-white">
                <img
                  src="assets/img/selektiando-logo.png"
                  width="200"
                  alt="Selektiando Logo"
                  className="img-fluid"
                  style={{ filter: "brightness(0) invert(1)" }}
                />
                <p>
                  Expertos en Recutamiento por más de 15 años, y ahora reclutamiento más rápido, preciso y humano con Inteligencia Artificial.
                </p>

                <p className="mt-3 small-text text-white">
                  © Selektiando.com - Todos los derechos reservados
                </p>
              </div>
            </div>

            <div className="col-md-12 col-lg-8">
              <div className="row">
                <div className="col-sm-6 col-md-4 col-lg-4 mb-4 mb-md-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Recursos</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <a href="/aviso-de-privacidad">Aviso de Privacidad</a>
                      </li>
    
                    </ul>
                  </div>
                </div>

                {/* REDES SOCIALES */}
                <div className="col-sm-6 col-md-4 col-lg-4 mb-4 mb-md-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Redes Sociales</h5>
                    <ul className="list-unstyled support-list">
                      <li className="mb-2">
                        <a href="https://www.facebook.com/selektiando" target="_blank" rel="noopener noreferrer">
                          <span className="ti-facebook mr-2"></span> Facebook
                        </a>
                      </li>
                          <li className="mb-2">
                        <a href="https://www.instagram.com/selektiando" target="_blank" rel="noopener noreferrer">
                          <span className="ti-instagram mr-2"></span> Instagram
                        </a>
                      </li>
                             <li className="mb-2">
                        <a href="https://www.linkedin.com/company/selektiando" target="_blank" rel="noopener noreferrer">
                          <span className="ti-linkedin mr-2"></span> LinkedIn
                        </a>
                      </li>
                     
                  
                     
                    </ul>
                  </div>
                </div>

                {/* CONTACTO */}
                <div className="col-sm-6 col-md-4 col-lg-4">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Contacto</h5>
                    <ul className="list-unstyled support-list">
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-location-pin mr-2"></span>
                        San Michelangelo<br />Guadalupe, Nuevo León
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-mobile mr-2"></span>
                        <a href="tel:+528185262144">+52 81 8526 2144</a>
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-email mr-2"></span>
                        <a href="mailto:buscotalento@selektiando.com">buscotalento@selektiando.com</a>
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-world mr-2"></span>
                        <a href="https://www.selektiando.com">www.selektiando.com</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </footer>
  );
}
